import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CopyIconHollow } from "../../assets/icons";
import { DownloadPdf } from "./index";
import { FaCheck } from "react-icons/fa";

import lynnImage from "../../assets/images/lynn-handsup.png";
import cloudImage from "../../assets/images/clouds.png";

const InsightsIntro = ({ teamName, id, workshopDate, socket, platform, mftPublicTeam }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const insightsIntro = platform === "mft" ?
    t("mft.insightsIntro", { returnObjects: true })
    : t("insightsIntro", { returnObjects: true });

  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(`${window.location.origin}/insights/${id}`);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
      console.log("Error while copying", error);
    }
  };

  return (
    <div className="bg-white-100 rounded-lg border-2 border-gray-250/40 p-6 md:p-8 relative my-12">
      {/* Lynn Character – breaking out of the card */}
      <div className="hidden md:block absolute -top-10 right-4 w-64 h-auto z-30 pointer-events-none">
        <img src={lynnImage} alt="Lynn character" className="w-full h-auto drop-shadow-xl" />
      </div>

      {/* Decorative Clouds – inside card */}
      <div className="hidden md:block absolute bottom-0 right-0 w-[28rem] h-auto z-10">
        <img src={cloudImage} alt="decorative clouds" className="w-full h-auto opacity-50" />
      </div>

      {/* INSIGHTS Label */}
      <div className="inline-block bg-orange-100 px-4 py-1 rounded-full mb-4 relative z-20">
        <span className="text-white-100 text-sm font-bold uppercase">
          {insightsIntro?.label || "INSIGHTS"}
        </span>
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-2xl">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-250 mb-4">
          {teamName || "[TEAM NAME]"}
        </h2>
        <p
          className="text-gray-250 mb-6 font-medium"
          dangerouslySetInnerHTML={{ __html: insightsIntro?.description }}
        />

        {/* Action Items */}
        <div className="flex flex-col gap-4">
          {/* Copy URL Action */}
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center shrink-0">
              <button
                onClick={handleCopy}
                className="w-8 h-8 flex items-center justify-center text-white-100">
                {!copied ? <CopyIconHollow /> : <FaCheck className="w-5 h-5" />}
              </button>
            </div>
            <p
              className="text-gray-250 flex-1"
              dangerouslySetInnerHTML={{ __html: insightsIntro?.copyAction }}
            />
          </div>

          {/* Download PDF Action */}
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center shrink-0 cursor-pointer">
              <DownloadPdf
                workshopId={id}
                downloadPDFTitle={`${teamName}-${workshopDate}`}
                socket={socket}
                buttonType="icon"
                className="text-white-100"
              />
            </div>
            <p
              className="text-gray-250 flex-1"
              dangerouslySetInnerHTML={{ __html: insightsIntro?.downloadAction }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsightsIntro;
